import { message } from "antd";
import { get } from "../../../utils/index";
import { l } from "../../../config/language";

/**
 *
 *
 * @param {Array} uploadRules // 上传限制的规则,{rule[必须是函数],message[函数]}
 *
 * @param {string} url 获得 oss 签名的url
 * @param {string} AccessToken 配置中cookie的auth_name值
 * @param {string} type 文件类型 file/img 可自定义，参考antd文档,默认 img
 * @param {string} showType 展示类型 (thumb-缩略图) (text-文本) (imgs-照片墙)，默认imgs
 * @param {funtion} formParams  请求上传接口时所带的参数
 * @param {number} limit 文件个数限制 0为不限制， 默认0
 * @param {number} size 文件大小限制 单位mb 0为不限制，默认0
 *
 * @param {boolean} isMultiple 是否多选
 * @param {boolean} soft 图片支持排序，拖拽
 * @param {boolean} isRead 是否只读，意味着无法后期上传
 * @param {String} uploadType 上传类型 oss huawei s3 aws minio
 *
 * @param {Function} ossFactory 凭证处理函数
 * @param {Function} onRemoveOk 删除点击ok回调
 * @param {Function} onRemoveCancel 删除点击取消回调
 * @param {Function} actionCallback 当文件操作完成后回调，成功、失败、错误都会调用
 * @param {Function} refLoad 当内部的上传组件加载完成调用，需要手动返回true
 *
 * @param {Function|Node} delPreview 自定义的删除预览
 * @param {Function|Node} uploadPreview 自定义的预览
 * @param {object} message 组件弹出提示，对应键传入函数即可接管
 * @param {object} uploadBtnParam 上传按钮的配置 当type为text或者thumb起效
 * @param {Array<string>} list 文件数据，格式为[url,url...url]
 * @param {boolean} showFilename 图片是否显示文件名称
 * 依赖 lodash
 * @class YxUpload
 * @extends {Component}
 */
export const defaulProps = function () {
  return {
    // 默认props
    showFilename: false,
    ossFactory: null,
    soft: false,
    extraList: null,
    uploadRules: [],
    uploadType: "oss",
    isConfirmDel: true,
    url: "", // 上传oss对应的ur
    isRead: false, // 是否只读
    type: "img", // 文件类型控制，默认为图片
    limit: 0, // 限制，为 0 则不限制文件数量
    list: null, // 文件列表 获得 oss 签名的url
    showType: "imgs", // 上传的文件类型限制 video
    isMultiple: true, // 是否支持多个文件同时上传，默认开启
    fileSize: 0, // 上传文件大小限制,为 0 则不限制。 单位MB
    AccessToken: "", // 配置中cookie的auth_name值
    delPreview: null,
    uploadPreview: null,
    load: function () {},
    actionCallback: function () {},
    onRemoveOk: function () {}, // 删除确认回调
    onRemoveCancel: function () {}, // 删除取消回调
    message: {
      delTitle: () => l("YxUpload.dt"),
      done: () => message.success(l("YxUpload.dnt")),
      error: () => message.error(l("YxUpload.ert")),
      remove: () => message.success(l("YxUpload.rt")),
      limit: () => message.error(l("YxUpload.lt")),
      fileSize: () => message.error(l("YxUpload.st")),
    },
    rules: {},
    inputParam: {},
    formItemParamer: {},
    uploadBtnParam: {},
    getFieldDecoratorParam: {
      initialValue: [],
      valuePropName: "list",
      // validateTrigger: 'uploadChange'
    },
  };
};

/**
 * 默认的state
 *
 * @param {*} props
 * @returns
 */
export const defaulState = function (props) {
  return {
    spin: true,
    full: false,
    fileList: [],
    errorList: [],
    loading: false,
    previewImage: null,
    uploadFormList: [],
    previewVisible: false,
    className: "yx_yxInput_upload",
    fileListByForm: [], // 从表单传入的list
    uploadType: get(props, "uploadType", "oss"),
  };
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/param.js